module.exports = __webpack_public_path__ + "img/S931.a5eddc52.jpg";